<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('common.filter_injuries')" :width="460" :fullscreen="isMobile" @input="onDialogInput"
        @close="hide">
        <v-row dense>
            <v-col cols="12" md="6">
                <kimsa-date-picker :label="$t('common.discharge_date_start')" solo flat force-value dense
                    color="secondary" @change="startDate = $event" :value="startDate" />
            </v-col>
            <v-col cols="12" md="6">
                <kimsa-date-picker :label="$t('common.discharge_date_end')" solo flat force-value dense color="secondary"
                    @change="endDate = $event" :value="endDate" :min="startDate" />
            </v-col>
            <v-col cols="12">
                <kimsa-combobox :label="$t('common.injury_type')" :placeholder="$t('common.select_placeholder')" dense
                    no-object item-text="label" :items="typeOptions" @change="type = $event;" :value="type" />
            </v-col>
            <v-col cols="12">
                <kimsa-combobox :label="$t('common.zone')" :placeholder="$t('common.select_placeholder')" dense
                    no-object item-text="label" :items="zoneOptions" @change="zone = $event;" :value="zone" />
            </v-col>
            <v-col cols="12">
                <kimsa-combobox :label="$t('common.condition')" :placeholder="$t('common.select_placeholder')" dense
                    no-object item-text="label" :items="conditionOptions" @change="condition = $event;" :value="condition" />
            </v-col>
            <v-col cols="12">
                <kimsa-combobox :label="$t('common.was_it')" :placeholder="$t('common.select_placeholder')" dense
                    no-object item-text="label" :items="wasItOptions" @change="wasIt = $event;" :value="wasIt" />
            </v-col>
        </v-row>
        <template #footer>
            <div class="filter-footer">
                <v-btn class="footer-btn footer-btn--ghost" depressed @click="reset">
                    {{ $t('common.reset') }}
                </v-btn>
                <v-btn class="footer-btn footer-btn--primary" depressed @click="applyFilter">
                    {{ $t('common.filter') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import KimsaCombobox from './inputs/KimsaCombobox.vue';
import KimsaDatePicker from './inputs/KimsaDatePicker.vue';
import BaseDialog from './BaseDialog.vue';

export default {
    components: { KimsaCombobox, KimsaDatePicker, BaseDialog },
    name: "FilterInjuriesDialog",
    data() {
        return {
            dialog: false,
            loading: false,
            startDate: null,
            endDate: null,
            type: null,
            zone: null,
            condition: null,
            wasIt: null,
        }
    },
    computed: {
        ...mapState(['config']),
        typeOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.injuries.type.map(value => ({ name: value, value, label: vm.injuryTypeLabel(value) }))
        },
        zoneOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.injuries.zone.map(value => ({ name: value, value, label: vm.injuryZoneLabel(value) }))
        },
        conditionOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.injuries.condition.map(value => ({ name: value, value, label: vm.injuryConditionLabel(value) }))
        },
        wasItOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.injuries.wasIt.map(value => ({ name: value, value, label: vm.injuryMomentLabel(value) }))
        },
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
    },
    methods: {
        ...mapActions(['bindConfig']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.startDate = null
            vm.endDate = null
            vm.type = null
            vm.zone = null
            vm.condition = null
            vm.wasIt = null
            vm.$emit('filter')
            vm.hide()
        },
        applyFilter() {
            const vm = this;
            let payload = {
                startDate: vm.startDate,
                endDate: vm.endDate,
                type: vm.type,
                zone: vm.zone,
                condition: vm.condition,
                wasIt: vm.wasIt,
            }
            vm.$emit('filter', payload)
            vm.hide()
        }
    },

}
</script>

<style scoped>
.filter-footer {
    display: flex;
}

.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
}

.footer-btn--ghost.v-btn {
    flex: 1;
    background: var(--v-surface2-base) !important;
    color: var(--v-txtSecondary-base) !important;
}

.footer-btn--primary.v-btn {
    flex: 2;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}
</style>